// Action Type Constants

export default {
    SET_PENDING_REQUESTS: "SET_PENDING_REQUESTS",
    SET_USER: "SET_USER",
    SET_META: "SET_META",
    SET_ACCESS_TOKEN: "SET_ACCESS_TOKEN",
}
